import { z } from "zod";
// ---------------------------------------------------------------------------
// Errors
// ---------------------------------------------------------------------------
export const evalErrorTypeSchema = z.enum([
    "UnitMismatch",
    "UndefinedVariable",
    "InvalidOperation",
    "WrongNumberOfArguments",
    "InvalidArgumentType",
    "UnsupportedUnitOperation",
    "DivisionByZero",
    "PropertyAccessOnNonObject",
    "IndexOutOfBounds",
    "FunctionNotFound",
    "UnsupportedResultType",
    "ArrayNotAllowedAsResult",
    "ExpectedSingleElement",
    "UndefinedProperty",
    "UnsupportedOperator",
    "UnsupportedNodeType",
    // Table-specific errors
    "UndefinedColumn",
    "NoIndexColumn",
    "IndexNotFound",
    "InvalidCondition",
    "RowNotFound",
    "EmptyTable",
    "NonNumericColumn",
    "NoValidData",
    "NonTimestampIndex",
    "InvalidFrequency",
    "InvalidAggregation",
    // Not an error: the analyte was looked for and not found (notdetected()).
    "NotDetected",
    // Not an error: the value does not apply to this test (notapplicable()).
    "NotApplicable",
    // An input is still blank, so there is nothing to compute yet.
    "MissingInput",
]);
/**
 * Formula results that are answers rather than failures. `notdetected()` and
 * `notapplicable()` travel through dependent formulas like errors, but are
 * stored as these statuses (next to OK and EVAL_ERROR) and shown as such.
 */
export const OUTCOME_STATUS = {
    NotDetected: "NOT_DETECTED",
    NotApplicable: "NOT_APPLICABLE",
};
/** The stored status of a formula result that is an outcome, or null for a real error. */
export function outcomeStatusOf(error) {
    const type = error?.type;
    return typeof type === "string" && Object.hasOwn(OUTCOME_STATUS, type)
        ? OUTCOME_STATUS[type]
        : null;
}
export const evalErrorSchema = z.object({
    type: evalErrorTypeSchema,
    message: z.string(),
});
//# sourceMappingURL=types.js.map